module.exports = __webpack_public_path__ + "img/30.e61ef38f.jpg";